import { lazy, Suspense } from "react";
import Header from "@/components/Header";
import Hero from "@/components/Hero";

const HowItWorks = lazy(() => import("@/components/HowItWorks"));
const Products = lazy(() => import("@/components/Products"));
const Testimonials = lazy(() => import("@/components/Testimonials"));
const Certifications = lazy(() => import("@/components/Certifications"));
const FAQ = lazy(() => import("@/components/FAQ"));
const CTA = lazy(() => import("@/components/CTA"));
const Footer = lazy(() => import("@/components/Footer"));

const Index = () => {
  return (
    <div className="min-h-screen bg-background" dir="rtl">
      <Header />
      <main>
        <Hero />
        <Suspense fallback={null}>
          <HowItWorks />
          <Products />
          <Testimonials />
          <Certifications />
          <FAQ />
          <CTA />
        </Suspense>
      </main>
      <Suspense fallback={null}>
        <Footer />
      </Suspense>
    </div>
  );
};

export default Index;
